// extracted by mini-css-extract-plugin
export default {"document_skelton":"documentUploaderAdapter_document_skelton__MEsPm"};